import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "lucide-react";
import { Fragment, ReactNode } from "react";

interface Props {
  children: ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  className?: string; // Optional className prop
}

export const Modal = ({ children, isOpen, setIsOpen, className }: Props) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setIsOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 dark:bg-zinc-900 dark:bg-opacity-40 bg-opacity-75 backdrop-blur-md transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg dark:bg-dark-primary bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:p-6${
                  className ? " " + className : ""
                }`}
              >
                <div>
                  <XIcon
                    className="absolute top-2 right-2 mt-2 mr-2 h-6 w-6 cursor-pointer text-zinc-400 hover:text-zinc-600 dark:text-zinc-300 dark:hover:text-zinc-500 transition"
                    onClick={() => setIsOpen(false)}
                  />
                </div>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
